import posthog from 'posthog-js';

const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

if (apiKey) {
  posthog.init(apiKey, {
    api_host: apiHost,
    autocapture: true,
    capture_pageview: true,
    disable_session_recording: false,
    persistence: 'localStorage+cookie',
  });
}

export default posthog;
